export default __webpack_public_path__ + "static/media/big-launch.c60f1fa1.svg";